export default {
	'forum.banUser': 'Ban User',
	'forum.charsRemaining': ' characters remaining.',
	'forum.deletePost': 'Delete Post',
	'forum.noCommentsInThread': 'No comments in thread.',
	'forum.noPosts': 'There are no posts.',
	'forum.noPostsMatchedSearch': 'No posts matched your search criteria.',
	'forum.postNotFollowing': 'You are not following any posts.',
	'forum.selectTags': 'Select Some Tags',
	'forum.unbanUser': 'Unban User',
	'forum.unbanConfirmation': 'Are you sure you want to unban this user?',
	'forum.unflagConfirmation': 'Are you sure you want to unflag this post?'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/forums.js